import React, { useState } from "react";
import { connect } from "react-redux";
import { Box } from "@mui/material";
import { login } from "../../store/thunks";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import { InputError } from "../common/InputError";
import { useForm } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import { post } from "../../api";
import { toast } from "react-toastify";

const LoginForm = ({ setStep, setEmail }) => {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({});
  const goTo = (link) => {
    navigate(link);
  };
  const handleLoginSubmit = async (data) => {
    setLoading(true);
    setEmail(data?.email);
    try{
      const url = "/api/auth/check-email";
      const res = await post(url, data);
      if (res?.status == 200) {
        if (res?.data?.isRegistered === true) {
          setStep("LoginAccount");
        } else {
          setStep("Create");
        }
      } else {
        toast.error("Something went wrong in log in. Please try again.")
      }
      setLoading(false);
    } catch(e) {
      toast.error("Something went wrong in log in. Please try again.")
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12 right-panel bg-white">
        <form onSubmit={handleSubmit(handleLoginSubmit)}>
          <h2 className="mb-2">Welcome</h2>
          <p>
            <small>
              To access this system, please enter your email address below to
              get started.
            </small>
          </p>
          <hr />
          <div className="form-group mt-2 mb-2">
            <label for="email">What's Your Email Address?</label>
            <input
              type="text"
              className="form-control"
              id="email"
              placeholder="Please enter your email here"
              {...register("email", {
                required: {
                  value: true,
                  message: `Please enter your email.`,
                },
                validate: {
                  maxLength: (v) =>
                    v.length <= 50 ||
                    "The email should have at most 50 characters",
                  matchPattern: (v) =>
                    /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    "Email address must be a valid address",
                },
              })}
            />
            {errors?.email && (
              <InputError
                message={errors?.email?.message}
                key={errors?.email?.message}
              />
            )}
          </div>
          {isLoading && (
            <Box sx={{ display: "flex", justifyContent: 'center', }}>
              <CircularProgress />
            </Box>
          )}
          {!isLoading && (
            <div className="form-group mt-4">
              <button
                type="submit"
                className="btn btn-primary rounded w-100 login-submit"
              >
                Next
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default connect(null, { login })(LoginForm);
